<template>
  <div class="bread-crumbs">
    <div class="main">
      <router-link :to="{ name: 'dashboard' }">
        <i class="fa fa-home" /> Home
      </router-link>
    </div>
    <div
      v-for="(crumb,i) in breadCrumbs"
      :key="i"
      class="crumb"
    >
      <i class="fa fa-caret-right" />
      <span
        v-if="!crumb.disabled"
        @click="go(crumb.href)"
      >{{ crumb.text }}</span>
      <span v-else>{{ crumb.text }}</span>
    </div>
  </div>
</template>

<style scoped>
.crumb span {
  cursor: pointer;
}
</style>

<script>
export default {
  computed: {
    crumbs() {
      return this.$route.fullPath.split('/').filter(crumb => {
        return crumb.length > 1;
      });
    },
    breadCrumbs() {
      let pathArray = this.$route.fullPath.split('/');
      pathArray.shift();
      const breadCrumbs = [];
      // needed to handle the intermediary entries for nested vue routes
      let breadcrumb = '';
      let lastIndexFound = 0;
      for (let i = 0; i < pathArray.length; ++i) {
        breadcrumb = `${breadcrumb}${'/'}${pathArray[i]}`;
        if (this.$route.matched[i]) {
          breadCrumbs.push({
            href: i !== 0 && pathArray[i - (i - lastIndexFound)]
                ? '/' + pathArray[i - (i - lastIndexFound)] + breadcrumb
                : breadcrumb,
            disabled: i + 1 === pathArray.length,
            text: this.$route.matched[i].meta.breadCrumb || pathArray[i]
          });
          lastIndexFound = i;
          breadcrumb = '';
        }
      }
      return breadCrumbs;
    }
  },
  methods: {
    go(href) {
      this.$router.replace(href);
    }
  }
}
</script>
